export const cilChevronDoubleUpAlt = ["24 24","<path d='M20.095 20.405l-8.095-8.095-8.095 8.095-1.061-1.061 9.155-9.155 9.155 9.155-1.061 1.061z'></path><path d='M20.095 12.905l-8.095-8.095-8.095 8.095-1.061-1.061 9.155-9.155 9.155 9.155-1.061 1.061z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-chevron-double-up-alt.js
// module id = null
// module chunks = 